// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIndividualDeductibleUpdateRequestDto } from './IIndividualDeductibleUpdateRequestDto';
import {
    IIndividualDeductibleUpdateRequestDtoFromJSON,
    IIndividualDeductibleUpdateRequestDtoFromJSONTyped,
    IIndividualDeductibleUpdateRequestDtoToJSON,
    IIndividualDeductibleUpdateRequestDtoToJSONTyped,
} from './IIndividualDeductibleUpdateRequestDto';

/**
 * 
 * @export
 * @interface IDeductibleUpdateRequestDto
 */
export interface IDeductibleUpdateRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IDeductibleUpdateRequestDto
     */
    health_policy_id: number;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleUpdateRequestDto
     */
    family_deductible_amount: number;
    /**
     * 
     * @type {Array<IIndividualDeductibleUpdateRequestDto>}
     * @memberof IDeductibleUpdateRequestDto
     */
    individual_deductibles?: Array<IIndividualDeductibleUpdateRequestDto>;
    /**
     * 
     * @type {Date}
     * @memberof IDeductibleUpdateRequestDto
     */
    effective_date: Date;
}

/**
 * Check if a given object implements the IDeductibleUpdateRequestDto interface.
 */
export function instanceOfIDeductibleUpdateRequestDto(value: object): value is IDeductibleUpdateRequestDto {
    if (!('health_policy_id' in value) || value['health_policy_id'] === undefined) return false;
    if (!('family_deductible_amount' in value) || value['family_deductible_amount'] === undefined) return false;
    if (!('effective_date' in value) || value['effective_date'] === undefined) return false;
    return true;
}

export function IDeductibleUpdateRequestDtoFromJSON(json: any): IDeductibleUpdateRequestDto {
    return IDeductibleUpdateRequestDtoFromJSONTyped(json, false);
}

export function IDeductibleUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductibleUpdateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'health_policy_id': json['health_policy_id'],
        'family_deductible_amount': json['family_deductible_amount'],
        'individual_deductibles': json['individual_deductibles'] == null ? undefined : ((json['individual_deductibles'] as Array<any>).map(IIndividualDeductibleUpdateRequestDtoFromJSON)),
        'effective_date': (new Date(json['effective_date'])),
    };
}

export function IDeductibleUpdateRequestDtoToJSON(json: any): IDeductibleUpdateRequestDto {
    return IDeductibleUpdateRequestDtoToJSONTyped(json, false);
}

export function IDeductibleUpdateRequestDtoToJSONTyped(value?: IDeductibleUpdateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'health_policy_id': value['health_policy_id'],
        'family_deductible_amount': value['family_deductible_amount'],
        'individual_deductibles': value['individual_deductibles'] == null ? undefined : ((value['individual_deductibles'] as Array<any>).map(IIndividualDeductibleUpdateRequestDtoToJSON)),
        'effective_date': ((value['effective_date']).toISOString().substring(0,10)),
    };
}

